import styles from './page.module.sass'
// @TODO: delete after new web is ready and replace with new content
// @TODO: get the data from contember
export default function TermsAndConditions() {
	return (
		<div className={styles.wrapper}>
			<div className={styles.main}>
				<h1>Terms and conditions</h1>
				<p>
					<strong>KiloMayo s.r.o.</strong> is a company with its registered office at Pštrossova 191/22, Nové Město, 110
					00 Prague 1, Czech Republic, registered in the Commercial Register maintained by the Municipal Court in Prague
					under the file no. C 392573, ID No. 19841698 (“<strong>KiloMayo</strong>&quot;). These Terms and Conditions
					contain the terms and conditions that govern your access to and use of the KiloMayo Services and form a
					binding agreement between the KiloMayo entity (“<strong>we</strong>”, “<strong>us</strong>” or “
					<strong>our</strong>”) and you or the entity that is entering into the legal agreement for the Services with
					us in a manner anticipated in Section 2 below (“<strong>you</strong>” or “<strong>Customer</strong>
					”).
				</p>
				<ol>
					{/* 1.  */}
					<li>
						<h2>Description of Services</h2>
						<ol>
							<li>
								We provide Software as a Service (“<strong>SaaS</strong>”) solution that is accessed through our
								proprietary software “360 ERP System KiloMayo” (“<strong>Software</strong>”) accessible at
								www.kilomayo.com and that consists of various solutions, plugins and applications (“
								<strong>Modules</strong>“) for management of gastronomy and hospitality establishments including
								restaurant operations management, transaction processing, ordering and warehouse logistics, management
								of staff and guests, mailings and marketing campaigns, data reports, and POS systems (“
								<strong>Services</strong>”). The Services are provided on a subscription basis for a minimum monthly
								subscription term.
							</li>
							<li>
								Unless otherwise agreed in writing with KiloMayo, your agreement with KiloMayo will always include, at a
								minimum, the Terms and Conditions set out in this document (the “<strong>Terms</strong>
								”).
							</li>
							<li>
								Your agreement with KiloMayo will also include all subscription rates and payment terms applicable to
								the Services/Modules chosen by you (the “<strong>Payment Terms</strong>”). The Payment Terms, including
								any related additional terms applicable to your subscription, are published on KiloMayo website, or are
								otherwise made available to you either within, or through your use of, the Service you subscribe to. If
								you enter into a separate binding purchase order with us for the provision of the Services (each an “
								<strong>Order</strong>”), these Terms will be also incorporated into the Order and the Order will define
								your subscription term, scope of the Services, fees and Payments Terms for the Services and any other
								specific terms that may apply to your use of the Services.
							</li>
							<li>
								The use of some Modules may be subject to specific terms and conditions (“
								<strong>Specific Terms</strong>”) which are further described in Section 16 below. If you use such
								Modules, you agree with these Specific Terms.
							</li>
							<li>
								If there is any conflict between the Order, the Specific Terms and these Terms, the documents will take
								precedence in the following order: the Order, then the Specific Terms, then these Terms.
							</li>
							<li>
								These Terms, together with the Payment Terms, the Order (if applicable) and the Specific Terms (if
								applicable), form a legally binding agreement between you and KiloMayo in relation to your use of the
								Services (the “<strong>Agreement</strong>”). It is important that you take the time to read them
								carefully.
							</li>
						</ol>
					</li>
					{/* 2.  */}
					<li>
						<h2>Accepting the Terms</h2>
						<ol>
							<li>
								If the person accepting these Terms is doing so on behalf of the Customer, such person represents that
								he or she has the authority to bind the Customer to these Terms. If you do not have such authority, or
								if you or the Customer do not agree with these Terms and Conditions, you must not accept this agreement
								and Customer may not use the services. By accepting the Order or using the Services, Customer agrees to
								be bound by these Terms.
							</li>
						</ol>
					</li>
					{/* 3.  */}
					<li>
						<h2>Language of the Terms</h2>
						<ol>
							<li>
								The Terms are provided in English. If we have provided you with a translation of the Terms, you agree
								that the translation is provided only for your convenience, and that the English language version of the
								Terms will govern your relationship with us.
							</li>
						</ol>
					</li>
					{/* 4.  */}
					<li>
						<h2>Provision of the Services</h2>
						<ol>
							<li>
								In order to provide the best possible experience for its users, we are constantly innovating the
								Services. This is why the Services may change from time to time without prior notice but such change
								will not result in material degradation of the Services. We reserve the right to cease providing any of
								the Modules; if you have pre-paid such Module, we will, as your sole and exclusive remedy, refund to you
								pro-rata the corresponding fees for Module(s) already paid by you equivalent to the part or remainder of
								the term in which you will not use the Module(s). Further, we may suspend the Services, without notice
								to you if (i) any payment is delinquent by more than thirty (30) days, or (ii) you breach any provision
								of these Terms.
							</li>
						</ol>
					</li>
					{/* 5.  */}
					<li>
						<h2>Your use of the Services</h2>
						<ol>
							<li>
								To access the Services, you or your individual end-users will be required to register into the our
								platform and provide identification, contact or similar details as part of the registration process for
								the Services or as part of your continued use of the Services.
							</li>
							<li>
								You agree to use the Services only for purposes that are permitted by (A) the Terms; (B) any applicable
								law, regulation, generally accepted practices, or guidelines in the relevant jurisdictions (including
								any laws regarding the export of data or software to and from the EU, the United States or other
								relevant countries).
							</li>
							<li>
								You agree not to access (or attempt to access) any of the Services by any means other than through the
								interface that is provided directly or indirectly by us, unless you have been specifically allowed to do
								so in a separate written agreement with us.
							</li>
							<li className={styles.is_noFlex}>
								You agree that you will not engage in any activity that interferes with or disrupts the Services (or the
								servers and networks which are connected to the Services). In particular, you agree not to engage in the
								following acts or cause or permit others to do so:
								<ol type="a">
									<li className={styles.is_initial}>
										Use the Services (as defined below) to violate applicable law or the Terms;
									</li>
									<li className={styles.is_initial}>
										Permit a third party to access the Services except your affiliates permitted pursuant to an Order or
										otherwise approved by the us;{' '}
									</li>
									<li className={styles.is_initial}>
										Sell, resell, rent, lease, distribute, assign or otherwise transfer the rights to the Services;
									</li>
									<li className={styles.is_initial}>
										Modify, translate, or create derivative works of the Services except as permitted by us;
									</li>
									<li className={styles.is_initial}>
										Use Services for timesharing or service bureau purposes or otherwise for the benefit of a third
										party;
									</li>
									<li className={styles.is_initial}>
										Remove, obscure or alter any proprietary rights notices (including copyright and trademark notices)
										which may be affixed to or contained in the Services or their outputs;
									</li>
									<li className={styles.is_initial}>Copy, frame, or mirror any part or content of the Services;</li>
									<li className={styles.is_initial}>
										Reverse engineer, decompile, disassemble or otherwise attempt to discover the source code or
										underlying ideas or algorithms of the Services or Software;
									</li>
									<li className={styles.is_initial}>
										Access the Services in order to build a competitive product or service, or copy any features,
										functions or graphics of the Services;
									</li>
									<li className={styles.is_initial}>
										Create any link to the Services or frame or mirror the content contained on, or accessible from, the
										Services;
									</li>
									<li className={styles.is_initial}>
										Use the Services to store or transmit infringing, libelous, or otherwise unlawful or tortious
										material, or to store or transmit material in violation of third-party privacy rights or copyright;
									</li>
									<li className={styles.is_initial}>
										Use the Services to knowingly upload, store, transmit or distribute material containing software
										viruses, worms, Trojan horses or other malicious code, files, scripts, agents or programs that may
										damage the operation of the Services or third-party’s computer, property of information;{' '}
									</li>
									<li className={styles.is_initial}>
										Interfere with or disrupt the integrity or performance of the Services or third-party data contained
										therein;
									</li>
									<li className={styles.is_initial}>
										Perform any simulated attack, penetration test, denial of service simulation or similar
										vulnerability test or scan of the Services; or
									</li>
									<li className={styles.is_initial}>
										Attempt to gain unauthorized access to the Services or their related systems or networks or
										unauthorized access to a third-party account or content created by or for our another customer.
									</li>
									<li className={styles.is_initial}>
										engage in any activity that may amount to the misuse of the Services or that seeks to circumvent the
										Services’ terms. For example, if we provide you with any portion of the Services as part of a trial,
										proof of concept (POC) or pilot, you may not engage in any excessive use of that portion of the
										Services, beyond what is permitted by the trial, POC or pilot of the Services (and as advertised for
										that portion of the Services at the time of the relevant promotion). We reserve the right to limit
										your activity on any of its trial, POC or pilot Services for any reason and without notice.
									</li>
								</ol>
							</li>
							<li>
								The Services can be used by you only for your own internal business purposes. You may not use the
								Services for the benefit of any third parties not explicitly approved by us.
							</li>
							<li>
								You acknowledge that additional third-party fees (such as internet service provider fee, third-party
								add-on fee or similar) may apply in connection with your use of the Services. Additional third-party
								fees are payable by you directly to the relevant third party and the relevant third party receiving such
								additional fees is responsible for the processing of such fees. You agree that you are solely
								responsible for payment of such fees or for maintaining appropriate level of funds where applicable. We
								have no responsibility to you or to any third party for payment of any such fees or for unavailability
								of Services due to your failure to do so.
							</li>
							<li>
								You acknowledge that use of the Services in breach of this Section 5 will be considered a material
								breach of the Agreement, with all consequences resulting therefrom.
							</li>
							<li>
								You agree and understand that you and your end-users are responsible for maintaining the confidentiality
								of passwords or other login credentials associated with any account you use to access the Services.
								Accordingly, you agree that you will be solely responsible for all activities that occur under your
								account.
							</li>
							<li>
								If you become aware of any unauthorized use of your password or of your account, you agree to notify us
								immediately.
							</li>
						</ol>
					</li>
					{/* 6.  */}
					<li>
						<h2>Fees and taxes</h2>
						<ol>
							<li>The Services are provided by us for consideration.</li>
							<li>
								You can pay for the Services either by entering your payment card information, or by any other means as
								published, from time to time, on the Services website. If you conclude an Order with us, we will issue
								an invoice for the Services which will be due within 14 days from the invoice date unless agreed
								otherwise in the Order.
							</li>
							<li>
								If you sign up for the Services online in the user interface for the Service, you agree that you will be
								charged periodically by KiloMayo pursuant to the payment conditions specified at checkout. In addition,
								you expressly acknowledge and agree that the initial price may change if you upgrade or change your
								subscription plan within the Service e.g., if you add any new Modules to your subscription. You will
								always be informed about the price modification prior to making the upgrade or changing your
								subscription.
							</li>
							<li>
								If you enter into an Order with us, the fees applicable to your use of the Services will be set forth in
								your Order which will also set forth the Payment Terms. We will invoice you for the Services, and you
								agree to pay the applicable fees, in accordance with the terms on the Order. Except as otherwise
								specified in these Terms or in the Order, fees for the Services will be charged upfront for an annual
								term. Payment obligations are non-cancelable, and fees paid are non-refundable, and quantities purchased
								cannot be decreased during the relevant subscription term stated on the Order.
							</li>
							<li>
								If any undisputed invoiced amount is not received by us by the due date, then without limiting our
								rights or remedies, those charges may accrue late interest at the rate of 1.5% of the outstanding
								balance per month, or the maximum rate permitted by law, whichever is lower.
							</li>
							<li>
								Fees for the Services as specified at checkout or in the Order (as applicable) exclude any and all
								applicable taxes, levies, duties or similar governmental assessments of any nature and similar fees
								(other than taxes solely based on our profit) now in force or imposed in the future on provision of the
								Services, including any sales, use or value added taxes, services tax or withholding tax, and you shall
								be responsible for payment of all such taxes and fees.
							</li>
							<li>
								No party shall have any right of holdback or set-off against any claims of the other Party under or in
								connection with the Agreement.
							</li>
							<li>We are not responsible for the payment processing provided by any third party.</li>
						</ol>
					</li>
					{/* 7.  */}
					<li>
						<h2>Customer Data</h2>
						<ol>
							<li>
								You retain ownership, copyright and any other intellectual property rights you hold in any electronic
								data, information, content or material that has not been publicly available and is submitted by you or
								on your behalf, to the Services or is collected and processed by you or on your behalf, through the
								Services (“<strong>Customer Data</strong>”). For the purposes of these Terms, Customer Data shall
								include any third-party data submitted by you through the Services. You are solely responsible for the
								accuracy, quality, integrity, legality, reliability, appropriateness and copyright, where aplicable, of
								Customer Data, including where applicable, for obtaining the necessary authorizations to use Customer
								Data.
							</li>
							<li>
								You grant us a non-exclusive, worldwide, terminable at will, and royalty free license during the term to
								use Customer Data only to the extent necessary to provide the Services, including responding to service
								or technical problems with the Service. This license includes the right to access and use Customer Data
								in the manner permitted by these Terms.
							</li>
							<li>
								Our responsibility with respect to Customer Data. We will not edit, delete, or disclose the contents of
								Customer Data unless authorized by you or unless we are required to do so by law or in good faith belief
								that such action is necessary to: (i) conform with applicable laws or comply with legal process served
								on us; (ii) protect and defend our rights or property; (iii) enforce the Agreement. We may collect,
								generate, use and disclose: (a) user statistical information such as usage or traffic patterns in
								aggregated form, or (b) other quantitative data derived from your use of the Service for industry
								analytics, benchmarking, analytics, marketing and other business purposes in support of the provision of
								the Services, but the information will not include personal data. We assume no responsibility for the
								deletion, correction, destruction, loss, infringement or failure of the Services to store any Customer
								Data that is caused other than by our own negligence or breach of our obligations under these Terms. Our
								sole obligation in the event of data loss shall be to use commercially reasonable efforts to restore
								Customer Data. To the extent Customer Data include personal data, we will protect them and process them
								in accordance with the Data Processing Agreement that is incorporated in the Agreement by reference.
							</li>
						</ol>
					</li>
					{/* 8.  */}
					<li>
						<h2>Proprietary rights</h2>
						<ol>
							<li>
								You acknowledge that we (or our licensors) own all legal rights, title and interest in and to the
								Services, including any intellectual property rights which subsist in the Services (whether those rights
								happen to be registered or not, and wherever in the world those rights may exist).
							</li>
							<li>
								These Terms are not a work made-for-hire agreement with regard to either party. Subject to the limited
								rights expressly granted hereunder, we reserve all rights, title and interests and all related
								intellectual property rights in and to the Services, reports generated through the Services and related
								documentation and any and all underlying Software, including modifications and derivatives created by
								us, databases, including data models, structures, data and aggregated statistical data contained
								therein. For the avoidance of doubt, if any reports or similar outputs from the Services generated by
								you through the use of the Service include our trade name, trademark, service mark, logo, domain name or
								our other distinctive brand features, their use in connection with that report is permitted and Section
								5.4 f) shall apply.
							</li>
						</ol>
					</li>
					{/* 9.  */}
					<li>
						<h2>License from us</h2>
						<ol>
							<li>
								We grant you a royalty-free, non-assignable and non-exclusive right and license to access and use the
								Services, on a subscription basis, for the term and in the scope agreed in the Agreement. Any Services
								unused during your subscription term (including but not limited to situations where you do not use the
								prepaid Services in full scope or if you do not use the prepaid Services for the full duration of the
								subscription term) shall expire at the end of the subscription term and cannot be transferred to
								consecutive terms or be refunded.
							</li>
							<li>
								When using some Modules, you may generate reports and/or other deliverables through your use of such
								Module(s). We grant you a royalty-free, perpetual, non-assignable and non-exclusive right and license to
								access and use, reproduce, display, distribute, and create derivative works of, any reports or other
								deliverables that you generate through your use of the Services. This is without prejudice to your
								ownership of Data, where such Customer Data is included in the reports and/or other deliverables
								generated through the Services.
							</li>
							<li>
								The license granted in this Section 9 is for the sole purpose of enabling you to use and enjoy the
								benefits of the Services as provided by us, in the manner permitted by this Agreement. You may not use
								the Services for the benefit of any third parties unless they are explicitly approved by us. You
								acknowledge that this is a SaaS agreement and that (A) the Software is not sold, and (B) we will not be
								delivering copies of the Software to you as part of the Services.
							</li>
						</ol>
					</li>
					{/* 10.  */}
					<li>
						<h2>Feedback</h2>
						<ol>
							<li>
								You may choose to share any ideas, feedback or suggestions regarding the Services (“
								<strong>Feedback</strong>”) with us. To the extent you provide any Feedback to us, you hereby grant us a
								non-exclusive, perpetual, irrevocable, royalty-free, worldwide right and license (with the right to
								grant sublicenses) to use, make, sell and otherwise exploit in any manner such Feedback without payment
								of any compensation to you.
							</li>
						</ol>
					</li>
					{/* 11.  */}
					<li>
						<h2>Term and Termination</h2>
						<ol>
							<li>
								The initial subscription term is indicated in the Services interface through which you purchased the
								Services or in the Order. The minimum subscription is one month. Your subscription will automatically
								renew for successive renewal terms of the same length as the initial subscription term, unless one of
								the parties provides written notice to the other party of its intent not to renew at least thirty (30)
								days prior to expiration of the pending term. Automatic renewal is not contingent upon us providing
								written notification of the applicable fees for each term.
							</li>
							<li>
								During the initial or any renewal term, each party may only terminate the Agreement for reasons
								stipulated in Section 11.3.
							</li>
							<li>
								Each of the parties may at any time terminate the Agreement if (A) the other party has materially
								breached any provision of the Agreement and failed to cure the breach (where such breach is capable of
								being cured) within a reasonable cure period provided by the other party, or has acted in a manner which
								clearly shows that it does not intend to or is unable to comply with the terms of the Agreement; or (B)
								a party is required to do so by law (for example, where the performance of the Agreement is or becomes
								unlawful); or (C) if the other party becomes the subject of a petition in bankruptcy or any other
								proceeding relating to insolvency, receivership, liquidation or assignment for the benefit of creditors.
								In addition, we may at any time terminate the Agreement if (D) we are transitioning to no longer
								providing the Services to users in the country in which you reside or from which you use the Services;
								or (E) the provision of the Services to you by us, in our opinion, no longer commercially viable. For
								the purposes of the Agreement, your failure to make timely payments under the Agreement will be
								considered a material breach of the Agreement if the due amount remains unpaid (fully or partially) more
								than 60 days after the payment due date. In the event you terminate the Agreement for a material breach
								committed by us as described in (A) above, or if we cease to provide any part or all of the Services
								during the Agreement term for reasons stipulated in (D) or (E) above, you shall not be required to make
								any payments for Services beyond the date of when you terminated the Agreement or when we cease to
								provide the Services (as applicable). In the event you prepaid the Services, we shall in such cases
								refund the pro-rata proportion of any pre-paid fee.
							</li>
							<li>
								All provisions of the Agreement which by their nature should survive termination or which may reasonably
								be interpreted or construed as surviving the termination, will survive such termination, including,
								without limitation, accrued rights to payment, confidentiality obligations, warranty disclaimers and
								limitations of liability. Termination of individual Orders shall not affect other pending Orders.
							</li>
						</ol>
					</li>
					{/* 12.  */}
					<li>
						<h2>Warranties and Exclusions</h2>
						<ol>
							<li>
								We warrant that the Services will perform substantially and materially in accordance with the functions
								described in the user documentation under normal use and circumstances by authorized users of the
								Services, in accordance with these Terms and our Service Level Agreement.
							</li>
							<li>
								Except as expressly stipulated otherwise in these Terms, the Services are provided “as is” and we, our
								subsidiaries and affiliates, and our licensors give no warranty with respect to them.
							</li>
							<li>
								In particular, we, our subsidiaries and affiliates, and licensors do not represent or warrant to you
								that (A) your use of the Services will meet your requirements; (B) your use of the Services will be
								uninterrupted, timely, secure or free from error; and (C) that defects in the operation or functionality
								of any Software used to provide the Services will be corrected.
							</li>
							<li>
								NO CONDITIONS, WARRANTIES OR OTHER TERMS (INCLUDING ANY IMPLIED TERMS AS TO SATISFACTORY QUALITY,
								FITNESS FOR PURPOSE, MERCHANTABILITY OR NONFRINGEMENT) APPLY TO THE SERVICES EXCEPT TO THE EXTENT
								OTHERWISE EXPRESSLY SET OUT IN THE AGREEMENT.
							</li>
							<li>
								Nothing in the Terms shall affect those statutory rights that you cannot contractually agree to alter or
								waive.
							</li>
							<li>
								The Services are accessed using a web browser and their compatibility is only guaranteed with the
								then-current version and one immediately preceding version of the following web browsers: Google Chrome,
								Firefox, Microsoft Edge, Apple Safari. If you choose to generate reports when using the Services, you
								may also choose to download them in a standard format such as csv., pdf, xml. or .xlsx. To read such
								downloaded files, you may be required to install additional software allowing you to open such files.
							</li>
							<li>
								Early Access. Upon your request, we may enable you to access a dedicated section on our platform with
								Services features and functionalities that are in development and/or testing phase and are not released
								as a part of the commercial Services offering (“Early Access Services”). You understand, acknowledge and
								agree, that: (i) we may discontinue and stop providing any Early Access Services at any time at its
								discretion and without prior notice to you, (ii) the Early Access Services may contain bugs, defects and
								errors and we have no obligation under these Terms or otherwise to correct any bugs, defects or errors
								in the Early Access Services or otherwise to support or maintain the Early Access Services and to the
								extent permitted under applicable law shall not be liable to you for any loss or damage arising from or
								connected with your use of the Early Access Services; (iii) the version of the applicable Early Access
								Service feature that we may make commercially available following the early access phase (“
								<strong>Commercial Release</strong>”) may or may not, based solely on our discretion, contain the
								functionality or functions originally included in the Early Access Services, and the Commercial Release
								may contain functions and functionality, and perform in a manner significantly different from the Early
								Access Services features and functionalities made available to you; (iv) Customer Data submitted to
								Early Access Services may not be secured and Schedule B hereto shall not apply to Early Access Services;
								and (iv) the performance of the Early Access Services is not subject to Schedule A – Service Level
								Agreement. Accordingly, the use of and any research or development performed, or business plans made by
								you regarding, or in reliance upon, the Early Access Services are entirely at your own risk.
							</li>
							<li>
								AI-Generated Content. Certain features of the Services use third-party generative AI Solutions, i.e.,
								automated tools that provide information or generate text based on their programming and training data.
								You acknowledge that any content you generate by using such third-party AI Solutions: (i) may contain
								incorrect elements, including but not limited to biases and/or offensive language; (ii) is based on the
								data and programming used to train the model; this means that third-party generative AI Solutions, its
								licensors and we assume no liability for any content generated by third-party AI Solutions and any use
								or publication thereof.
							</li>
						</ol>
					</li>
					{/* 13.  */}
					<li>
						<h2>Indemnification </h2>
						<ol>
							<li>
								We will defend any action brought by a third party against you to the extent that the action is based on
								a claim that the Service provided by us to you, and as used within the scope of these Terms, directly
								infringes such third party’s intellectual property rights, and we shall hold you harmless from any
								liability for any costs and damages ordered by a court as a result of such action or resulting from a
								monetary settlement thereof, provided that (A) you notify us promptly in writing of the action (and all
								prior claims relating to such action), (B) we are given sole control of the defense and all negotiations
								for settlement or compromise of the action provided it releases you of all liability, and (C) you
								reasonably cooperate with us in such defense, including without limitation making available to us all
								relevant documents and other information in your possession and by making your personnel available to
								testify or to consult with us or our attorneys. The claims against us based on this Section can be
								brought within one (1) year from the expiry or termination of this Agreement.
							</li>
							<li>
								You shall defend us against any claim, demand, suit or proceeding made or brought against us by a third
								party alleging that your (i) uploading, provision, or use of any Customer Data (including any
								third-party content submitted by you through the Services) and/or (ii) use of the Services is in breach
								of these Terms, infringes or misappropriates the intellectual property rights of a third party or
								violates applicable law, and shall indemnify us for any damages, attorney fees and costs incurred in
								connection therewith; provided we promptly give you written notice of the claim, demand or notice of
								suit or proceeding brought against us (provided that you may not settle the claim against us unless it
								releases us of all liability) and provide you with reasonable assistance at your expense.
							</li>
							<li>
								We will have no liability or obligation with respect to any infringement or misappropriation claim based
								upon: (A) any use of the Services not in accordance with the Agreement or for purposes not intended by
								us, (B) any use of the Services in combination with other products, equipment, software or data not
								supplied by us, (C) any modification of the Services made by any person other than us where such
								modification is not authorized by us, or (D) any use of the Services other than the most current version
								made available to you.
							</li>
							<li>
								If the Services are likely to become the subject of an infringement or misappropriation claim, we may,
								at our sole option and expense, either: (A) procure for you the right to continue to use the said
								Services pursuant to these Terms; or (B) replace or modify said Services to make them non-infringing; or
								(C) terminate the applicable Order and your right to use the Services, and refund to you any unused
								pre-paid fees for said Services as of the date of termination. SECTIONS 13.1, 13.3 AND 13.4 STATE OUR
								ENTIRE LIABILITY AND YOUR SOLE AND EXCLUSIVE REMEDY FOR INFRINGEMENT AND MISAPPROPRIATION CLAIMS AND
								ACTIONS BASED ON ANY SERVICES OR PRODUCTS PROVIDED BY US.
							</li>
						</ol>
					</li>
					{/* 14.  */}
					<li>
						<h2>Limitation of liability </h2>
						<ol>
							<li>
								Nothing in the Agreement shall exclude or limit our liability for losses which may not be lawfully
								excluded or limited by applicable law.
							</li>
							<li>
								TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WHATEVER THE LEGAL BASIS FOR THE CLAIM, WE WILL NOT
								BE LIABLE FOR ANY INDIRECT DAMAGES (INCLUDING, WITHOUT LIMITATION, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL
								DAMAGES OF ANY KIND WHATSOEVER (INCLUDING, WITHOUT LIMITATION, ATTORNEYS&apos; FEES), DAMAGES FOR LOST
								PROFITS OR REVENUES, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS INFORMATION) DUE TO, RESULTING FROM, OR
								ARISING IN CONNECTION WITH THE AGREEMENT, INCLUDING, WITHOUT LIMITATION, OUR PERFORMANCE OR FAILURE TO
								PERFORM.
							</li>
							<li>
								Except for liabilities arising out of our indemnification obligations hereunder, our liability for
								damage incurred by you as a result of or in connection with the Services shall be limited to direct
								damages and shall not exceed the amount paid or payable by you to us for the Services giving rise to
								that liability during: a) the last twelve months before the occurrence of our liability (or amount
								corresponding to a twelve-month Service fee, as applicable), if you subscribed to the Services on at
								least one year (12 months) subscription basis; b) the last three months before the occurrence of our
								liability (or amount corresponding to a three-month Service fee, as applicable), if you subscribed to
								the Services on a monthly basis. The parties agree that this limitation reflects the damage that can be
								foreseen at the time of conclusion of the Agreement between you and us, taking into account all
								circumstances the parties know or should know while exercising due care and that can arise from a breach
								of our obligations under these Terms.
							</li>
						</ol>
					</li>
					{/* 15.  */}
					<li>
						<h2>Confidentiality </h2>
						<ol>
							<li>
								Definition of Confidential Information. As used herein, “<strong>Confidential Information</strong>”
								means all information disclosed by a party (“<strong>Disclosing Party</strong>”) to the other party (“
								<strong>Receiving Party</strong>”), whether orally or in writing, that is designated as confidential or
								that should reasonably be understood to be confidential given the nature of the information and the
								circumstances of disclosure. Except as expressly authorized, the Receiving Party will hold in confidence
								and not use or disclose any Confidential Information. However, Confidential Information shall not
								include any information that (A) is or becomes generally known to the public without breach of any
								obligation owed to the Disclosing Party; (B) was rightfully in its possession or known to the Receiving
								Party prior to its disclosure by the Disclosing Party without breach of any obligation owed to the
								Disclosing Party; (C) is rightfully received by a third party without breach of any confidentiality
								obligation;(D) was independently developed by employees of Receiving Party; or (E) is required to be
								disclosed in order to enforce these Terms or pursuant to a regulation, law or court order (but only to
								the minimum extent required to comply with such regulation or order and with advance written notice to
								the Disclosing Party to the extent legally permitted).
							</li>
							<li>
								Both Parties hereby agree, during the term of the Agreement and for a period of three years thereafter,
								to maintain as confidential all material, non-public Confidential Information, which it learns about the
								Disclosing Party as a result of its respective performance under these Terms and, except as may be
								required by applicable law or regulation, to refrain from disclosing any Confidential Information to any
								third party and to disclose such Confidential Information only to those agents, employees,
								representatives and professional advisors of the Receiving Party and/or its affiliates who have a need
								to know such Confidential Information for purposes of the Agreement.
							</li>
							<li>
								The Receiving Party may disclose Confidential Information of the Disclosing Party to the extent
								compelled by law to do so, provided the Receiving Party gives the Disclosing Party prior notice of the
								compelled disclosure (to the extent legally permitted) and reasonable assistance, at the Disclosing
								Party&apos;s cost, if the Disclosing Party wishes to contest the disclosure. If the Receiving Party is
								compelled by law to disclose the Disclosing Party’s Confidential Information as part of a civil
								proceeding to which the Disclosing Party is a party, and the Disclosing Party is not contesting the
								disclosure, the Disclosing Party will reimburse the Receiving Party for its reasonable cost of compiling
								and providing secure access to that Confidential Information.
							</li>
						</ol>
					</li>
					{/* 16.  */}
					<li>
						<h2>General provisions </h2>
						<ol>
							<li>
								Any changes to the Agreement shall be made by a written amendment and shall be effective once both
								parties have signed such amendment.
							</li>
							<li>
								The Agreement constitutes the entire agreement between you and us and governs your use of the Services
								(excluding any services which we may provide to you under a separate written agreement), and completely
								replaces any prior agreements between you and us in relation to the Services.
							</li>
							<li>
								The Agreement, and your relationship with us under the Agreement, shall be governed by, and construed
								and enforced in accordance with, the laws of the Czech Republic, without regard to conflict of law
								principles thereunder, and the parties agree to submit to the jurisdiction of the courts of the Czech
								Republic to resolve any legal matters arising from the Terms. Notwithstanding this, you agree that we
								shall still be allowed to apply (A) for payment orders (or otherwise enforce payment for Services
								provided under the Agreement) in the jurisdiction in which you have your registered seat or principal
								place of business, and (B) for injunctive remedies (or an equivalent type of urgent legal relief) in any
								jurisdiction.
							</li>
							<li>
								You agree that we may provide you with notices by email or regular mail; technical notices may be posted
								on the Services website. All legal notices addressed to us shall be in writing and shall be sent via
								certified or registered mail (with a copy sent via e-mail), return receipt requested, or overnight
								courier service. Notices shall be addressed to KiloMayo s.r.o., Pštrossova 191/22, Nové Město, 110 00
								Prague 1, Czech Republic, and an e-mail copy to kilomayo@kilomayo.com.
							</li>
							<li>
								We and our affiliates may identify you as KiloMayo&apos;s customer and display your company name and/or
								logo in our marketing materials (including but not limited to those published on websites and social
								media platforms) and in the course of our sales and promotional activities. We may also disclose your
								company name in connection with any survey or benchmarking study that we perform. With your approval, we
								may also issue a press release or customer success story identifying you as our customer and describing
								your utilization and benefits that you receive from the use of our Services. The content of any press
								release or published success story shall be subject to your prior approval.{' '}
							</li>
							<li>
								During the term of the Order and or a period of 6 months following the termination or expiration of the
								Agreement (the “<strong>Restricted Period</strong>”), neither party shall solicit the employment of or
								otherwise entice away from the employment of the other party any individual employee or independent
								contractor employed or engaged by such other party during the Restricted Period without the prior
								written consent of such party. Nothing in this Section 16.7 shall restrict a party from (A) making any
								general solicitation of employment that is not specifically directed at any employee of the other party;
								or (B) hiring any employee of the other party following a reverse solicitation by that employee. This
								Section will not apply in the event we should cease conducting all business operations.
							</li>
							<li>
								You understand and acknowledge that we may be subject to laws and regulations that prohibit export or
								diversion of certain software and technology to certain countries (“Export Laws”). You will comply with
								the Export Laws in effect from time to time as they relate to all aspects of these Terms and our
								Services and Software.
							</li>
							<li>
								Except for performance of a payment obligations, neither party will be responsible for any failure to
								perform or delay in performing any of its obligations under the Terms where and to the extent that such
								failure or delay results directly or indirectly from an event beyond such party’s reasonable control.
							</li>
							<li>
								The parties agree that if one of them does not exercise or enforce any legal right or remedy which is
								contained in the Terms (or which such party has the benefit of under any applicable law), this will not
								be taken to be a formal waiver of such party’s rights and that those rights or remedies will still be
								available to it.
							</li>
							<li>
								If any court of law, having the jurisdiction to decide on this matter, rules that any provision of the
								Terms is invalid, then that provision will be removed from the Terms without affecting the rest of the
								Terms. The remaining provisions of the Terms will continue to be valid and enforceable.
							</li>
							<li>
								Neither Party may assign any of its rights nor delegate any of its duties under these Terms without the
								prior written consent of the other Party, which consent will not be unreasonably withheld, provided that
								we may use independent service providers/contractors to deliver Services. Any unauthorized assignment of
								these Terms will be null and void. Notwithstanding the foregoing, either party may assign these Terms in
								its entirety (including Orders, and Annexes), without consent of the other Party, to the acquiring
								person in connection with a merger, acquisition, corporate reorganization, or sale of all or
								substantially all of its assets not involving a direct competitor of the other Party. A Party’s sole
								remedy for any purported assignment by the other Party in breach of the paragraph shall be, at the
								non-assigning Party’s election, termination of the Agreement upon written notice to the assigning Party.
								Subject to the foregoing, these Terms shall bind and inure to the benefits of the Parties, their
								respective successors and permitted assigns.
							</li>
							<li>
								Sometimes when you use the Services, you may (as a result of or through your use of the Services) use a
								service or download a piece of software or purchase goods, which are provided by another person or
								company. Your use of these other services, software or goods may be subject to separate terms between
								you and the company or person concerned. If so, the Agreement does not affect your legal relationship
								with these other companies or individuals, and you remain responsible for complying with the terms of
								use of such third party&apos; services, software or goods. If you use third parties&apos; services,
								software or goods while using the Services, you declare that you act in compliance with their terms of
								use.
							</li>
							<li>
								If you use the following Modules, you also agree with the Specific Terms applicable to the use of such
								Modules, which are incorporated to these Terms.
							</li>
						</ol>
					</li>
				</ol>
			</div>
		</div>
	)
}
